module.exports = __webpack_public_path__ + "img/u176.d030f58f.svg";